import SingupAlbumSelect from './SignupAlbumSelect';

export default SingupAlbumSelect;
